// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2kcod","left":"InfoRow_left__6gaBG"};